module.exports = __webpack_public_path__ + "img/poster-publicidad.90430ee9.png";